import { EntityImageConfig } from 'components/upload-image-modal';
import { ROLE_CODES } from 'constants/role.constants';
import { ValidatorFn, ValidationErrors, FormControl } from '@angular/forms';

export const NON_UNIQUE_USERS_MESSAGE =
  'User(s) with the same Email is already in Certemy with the same Role and under the same Organization in active status. Please remove these User(s) to complete invite';

export const NON_UNIQUE_INTERNAL_ID_MESSAGE =
  'WARNING: The internal user ID you have entered is already in use for another user in your organization.';

export const VALIDATION_ERRORS = {
  INVALID_EMAIL: 'Please enter a valid email',
  DUPLICATED_EMAIL:
    'You have entered the same e-mail address more than once. Please update one of the e-mail addresses',
  DUPLICATED_INTERNAL_ID: 'Please make sure one user with the unique internal ID is invited',
  EMPTY_FIELDS: 'Please fill out all fields',
  TITLE: 'WARNING: Please select a title',
  INVALID_MOBILE_PHONE_NUMBER: 'Invalid phone number entered (please include 10 digits)',
};

export const HELP_MESSAGES = {
  LOCATIONS:
    'Please select the country, {region}, and {office} where the employee is {location}. The employee may only be listed in a single {office}. This will determine which admin users will be able to manage this employee based on the location(s) specified for the admin users set up in your organization.',
  LOCATIONS_ADDITIONAL: 'If the employee works in multiple locations, please indicate those here.',
  TITLE:
    'Please select a Title for the administrator in your organization. These titles are set up under “Settings: Labels.” Please select the title that is closest to that of the user you are setting up in the platform. They are currently used for display purposes only but will eventually be used to determine access to various parts of the platform.',
  ROLE: 'Please select the appropriate role for this user. Roles allow you to treat a group of professionals together in reports. They also can control automatic assignments into workflows.',
  NO_ORGANIZATION_ROLES_MESSAGE: 'No organization roles. Please create one by clicking ',
  NO_ORGANIZATION_ROLES_ERROR: 'No organization roles. Please create one by clicking link above',
  MANAGER:
    'Optional. You may add a manager for this new user. The combination of locations and managers determines which employees can be viewed by admin users.',
  LEGAL_NAME_INDIVIDUAL:
    'The legal name should be the name that is associated with licenses/credentials filed with federal, state, or local regulatory bodies. This name will be used for primary source verification (PSV).  For professionals/employees, the legal name may include a middle initial or name, but is optional. Please note that the “first name” and “last name” fields will be displayed in all reports, and the “legal name” fields will be used for license verification.',
  LEGAL_NAME_FACILITY:
    'The legal name should be the name that is associated with licenses/credentials filed with federal, state, or local regulatory bodies. This name will be used for primary source verification (PSV). For facilities/entities, the legal name should be the name of the business as registered with federal, state, or local regulatory bodies and is required. Please note that the “name” filed will be displayed in all reports, and the “legal name” will be used for license verification.',
};

export interface IInviteProfile {
  additionalCountryIds: number[];
  additionalOfficeIds: number[];
  additionalRegionIds: number[];
  avatar: EntityImageConfig;
  country_id: number;
  country_ids: number[];
  email: string;
  first_name: string;
  last_name: string;
  mobileCountryId: number;
  mobilePhoneNumber: string;
  office_id: number;
  office_ids: number[];
  organizationRoleId: number;
  profile_type_id: number;
  region_id: number;
  region_ids: number[];
  organization_id: number;
  role_id: ROLE_CODES;
  profile_id: number;
  organization_profile_id: string;
  organization_country_id: number[];
  organization_region_id: [{ value: number[], disabled?: boolean }, ValidatorFn];
  organization_office_id: [{ value: number[], disabled?: boolean }, ValidatorFn];
  organization_country_ids: number[];
  organization_region_ids: [{ value: number[]; disabled?: boolean }, ValidatorFn];
  organization_office_ids: [{ value: number[]; disabled?: boolean }, ValidatorFn];
  legalFirstName: [string,
      [(control: FormControl<string>) => ValidationErrors, ValidatorFn] | []
  ];
  legalLastName: string;
  legalMiddleName: string;
}
